import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const PageHero = ({ kicker, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden pt-28 sm:pt-36 lg:pt-40">
    <div className="absolute inset-0 -z-10">
      {image && <img src={image} alt="" className="h-full w-full object-cover opacity-25" />}
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/90 to-background" />
      <div className="absolute inset-0 bg-gradient-hero" />
      <div className="absolute inset-0 bg-grid opacity-50" />
    </div>
    <div className="section-x pb-14 sm:pb-16">
      <div className="container-tmt max-w-4xl">
        {kicker && (
          <motion.span
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
            className="kicker inline-flex items-center gap-2 rounded-full border border-primary/25 bg-primary/10 px-4 py-1.5"
          >
            <ShieldCheck className="h-3.5 w-3.5" /> {kicker}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.08 }}
          className="mt-6 font-display text-4xl font-semibold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.18 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground"
          >
            {subtitle}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.28 }}
            className="mt-8"
          >
            {children}
          </motion.div>
        )}
      </div>
    </div>
  </section>
);
